module.exports = __webpack_public_path__ + "static/media/fabric-3layer.702554ae.png";